class NumberConverter {
  static toPersianNumber(input: string): string {
    const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    return input.replace(/\d/g, (digit) => persianDigits[parseInt(digit)]);
  }

  /**
   * Converts Persian (U+06F0) and Arabic-Indic (U+0660) digits to Latin.
   *
   * The Arabic-Indic range was missing, so digits from an Arabic keyboard or
   * some Android IMEs survived untouched and were then rejected by validation
   * regexes that only match Latin \d.
   */
  static toEnglishNumber(input: string): string {
    return input
      .replace(/[\u06F0-\u06F9]/g, (digit) =>
        String(digit.charCodeAt(0) - 0x06f0),
      )
      .replace(/[\u0660-\u0669]/g, (digit) =>
        String(digit.charCodeAt(0) - 0x0660),
      );
  }

  /**
   * For fields that hold digits only. Converts the script, then strips the
   * whitespace, separators and invisible bidi marks that ride along with a
   * code pasted out of a document \u2014 those made a correct value look like the
   * wrong length. Mirrors Digits::normaliseNumeric() on the api.
   */
  static toNumericOnly(input: string): string {
    return NumberConverter.toEnglishNumber(input).replace(
      /[\s\-_\u200B-\u200F\uFEFF]/g,
      '',
    );
  }
}

export default NumberConverter;
